import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import pdf from "../../assets/ZannyMaholobela_CV.pdf";
// import Squares from '../Squares/Squares';


function ResumeNew() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="resume-page" style={{ position: "relative", overflow: "hidden", background: "#1a1a1a" }}>
      {/* Animated background */}
      {/* <div className="background-animation">
        <Squares
          speed={0.5}
          squareSize={40}
          direction='diagonal'
          borderColor='rgba(0, 153, 112, 0.15)'
          hoverFillColor='rgba(0, 153, 112, 0.1)'
        />
      </div> */}
      <Container fluid className="resume-section">
      

        <Row className="resume">
          <Col className="d-flex justify-content-center">
            <object
              data={pdf}
              type="application/pdf"
              width={width > 786 ? "70%" : "100%"}
              height={width > 786 ? "800px" : "600px"}
              style={{
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.3)"
              }}
            >
              <p style={{ color: "white", textAlign: "center", padding: "20px" }}>
                Your browser does not support PDFs. 
                <br />
                <a href={pdf} target="_blank" rel="noopener noreferrer" style={{ color: "#8a49a8" }}>
                  Click here to download the PDF
                </a>
              </p>
            </object>
          </Col>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative", marginTop: "30px" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" ,}}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
